const $form = $('section.contact-form .wpcf7');

if($form.length > 0) {
  $form[0].addEventListener( 'wpcf7mailsent', function( event ) {
    if ( '15020' == event.detail.contactFormId ) {
      location = '/takk';
    }}, false );
}